// extracted by mini-css-extract-plugin
module.exports = {"root":"_71dd96","withSticky":"_25ad0a","background":"_b60b6b","container":"_80969a","isSticky":"_f5f10e","productInfo":"_8b581f","divider":"_df45af"};